import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import compliance from 'data/compliance.json'

/**
 * Short admissions, scholarship and visa disclaimer. It is shown next to
 * application forms and on the pages where students read about our services,
 * so the limits of what UHDSS can do are easy to find.
 */
function AdmissionsNotice({ className = '' }) {
  return (
    <div className={`alert alert-light border shadow-sm ${className}`} role='note'>
      <p className='dark-blue fs-6 mb-2'>
        <strong>Please note: </strong>
        {compliance.admissions.shortDisclaimer}
      </p>
      <Link className='fs-6 text-decoration-none' to='/admissions-disclaimer'>
        Read the full admissions, scholarship and visa disclaimer
      </Link>
    </div>
  )
}

AdmissionsNotice.propTypes = {
  className: PropTypes.string
}

export default AdmissionsNotice
